"use client"

import { useQuery } from "@tanstack/react-query"
import {
  getWhatsappSignupConfigAction,
  type WhatsappSignupConfig,
} from "@/server-actions/whatsapp-connect"

export const whatsappSignupConfigQueryKey = ["whatsapp-signup-config"] as const

/** Public appId + Embedded Signup config id for the client FB SDK. */
export function useWhatsappSignupConfigQuery() {
  return useQuery<WhatsappSignupConfig>({
    queryKey: whatsappSignupConfigQueryKey,
    queryFn: async () => {
      const result = await getWhatsappSignupConfigAction({})
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
